import { Emitter } from './emitter.js';

/**
 * A simple disposable interface that can be used to free resources
 * when the dispose() method is called on it.
 */
export class Disposable {
	/**
	 * Emits right before the Disposable is disposed
	 */
	private onDisposeEmitter = new Emitter<void>();

	/**
	 * Tells if the disposable has been disposed
	 */
	disposed = false;

	/**
	 * Creates a new Disposable
	 * @param onDisposeHandler An optional handler that is called when the disposable is disposed
	 */
	constructor(private onDisposeHandler?: () => void) {}

	/**
	 * Disposes the disposable and calls the onDispose handler
	 */
	dispose() {
		if (this.disposed) return;
		this.disposed = true;
		this.onDisposeEmitter.emit();
		this.onDisposeEmitter.dispose();
		this.onDisposeHandler?.();
	}

	/**
	 * Registers a listener that is called right before the disposable is disposed
	 */
	onDispose(listener: () => void) {
		return this.onDisposeEmitter.subscribe(listener);
	}
}
